// assets
import { IconBrandChrome, IconHelp, IconFiles } from '@tabler/icons';

// constant
const icons = { IconBrandChrome, IconHelp, IconFiles };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const createNavPages = (accessLevels) => {
    const { itAccess, userAccess } = accessLevels;
    const hasAnyAccess = itAccess || userAccess;

    return {
        id: 'navigation-items',
        type: 'group',
        children: [
        {
            id: 'portal-admin',
            title: 'Portal',
            type: 'item',
            url: '/portal',
            icon: icons.IconBrandChrome,
            breadcrumbs: false
        },
        hasAnyAccess && {
            id: 'purchase-orders',
            title: 'Purchase Orders',
            type: 'item',
            url: '/purchase-orders',
            icon: icons.IconFiles,
            breadcrumbs: false
        }
        ].filter(Boolean) // Filter out null values
    };
};

export default createNavPages;